export const asyncForEach: (array: any[], callback: (item: any) => Promise<void>) => Promise<void> = async (array, callback) => {
    for (let i: number = 0; i < array.length; i++) { // eslint-disable-line
        await callback(array[i]);
    }
};

export const wait: (time: number) => Promise<void> = (time) => {
    return new Promise((resolve) => setTimeout(resolve, time));
};
